<ng-container *transloco="let t" xmlns="http://www.w3.org/1999/html">
    <div class="row">
        <div class="col-md-7">
            <h2>{{ t('KIBON.KIBON_CONFIG.TITLE') }}</h2>

            <fieldset>
                <legend>
                    <h3>{{ t('KIBON.KIBON_CONFIG.KIBON_EINGEWOEHNUNG_POSITION_SINCE') }}</h3>
                </legend>
                <p>{{ t('KIBON.KIBON_CONFIG.KIBON_EINGEWOEHNUNG_POSITION_SINCE_INFO') }}</p>
                <div class="row">
                    <div class="col-lg-4 col-md-6 normal-abstand-bottom">

                        <dvlib-click-2-edit
                            #eingewoehnungPositionSince
                            [text]="eingewoehnungPositionSinceYear() ? t('KIBON.KIBON_CONFIG.KIBON_EINGEWOEHNUNG_POSITION_PERIODE', {period: eingewoehnungPositionSincePeriod()}) : undefined"
                            [label]="t('KIBON.KIBON_CONFIG.KIBON_EINGEWOEHNUNG_POSITION_PERIODE')"
                            (save)="submitForm()">
                            <ng-template dvlibEditMode>
                                <dvlib-datepicker-textfield
                                    name="eingewoehnungPositionSinceYear"
                                    [dvlibClick2Edit]="eingewoehnungPositionSince"
                                    [customOptions]="periodPickerConfig"
                                    [(ngModel)]="eingewoehnungPositionSinceYear"
                                    [attr.aria-label]="t('KIBON.KIBON_CONFIG.KIBON_EINGEWOEHNUNG_POSITION_PERIODE')"
                                    [placeholder]="t('KIBON.KIBON_CONFIG.KIBON_EINGEWOEHNUNG_POSITION_PERIODE')"/>
                            </ng-template>
                        </dvlib-click-2-edit>
                    </div>
                </div>
            </fieldset>

        </div>
    </div>
</ng-container>

